import { IConfig } from "./IConfig";

const configProd: IConfig = {
  trackingCodeUrl: "cdn.livechatinc.com/tracking.js",
  dontTrackLicenseActivity: true,
  amplitudeKey: "841104a62d8040f86beb1b507a0ea8ee",
  amplitudeQueue: "https://api.text.com/product-event/v2/event/amplitude",
};

export default configProd;
